export default __webpack_public_path__ + "static/media/063.6b9a8116.jpg";